import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@hotwired/turbo-rails';

// Bpart Scripts
import '~/scripts/register-as-organization';
import '~/scripts/search';
import '~/scripts/vote';
import '~/scripts/splide';

// Alpine
import Alpine from 'alpinejs';
import charCount from '../alpine/char-count';
import checkboxesField from '../alpine/checkboxes-field';
import cookieConsent from '../alpine/cookie-consent';
import dropdown from '../alpine/dropdown-public';
import entriesSearch from '../alpine/entries-search';
import entriesTranslation from '../alpine/entries-translation';
import entryReceiptProcessing from '../alpine/entry-receipt-processing';
import fileUpload from '../alpine/file-upload-public';
import flashLayer from '../alpine/flash-layer';
import formErrorHandler from '../alpine/form-error-handler';
import maplibrePublic from '../alpine/maplibre-public';
import newsItemsCategories from '../alpine/news-items-categories';
import opinionScale from '../alpine/opinion-scale';
import scrollToInvalid from '../alpine/scroll-to-invalid';
import skiplinks from '../alpine/skiplinks';
import socialMediaSharer from '../alpine/social-media-sharer';
import highlight from '../alpine/search-result-highlighter';
import voterRRN from '../alpine/voter-rrn';
import nudging from '../alpine/nudging';

// Alpine
window.Alpine = Alpine;
Alpine.data('charCount', charCount);
Alpine.data('checkboxesField', checkboxesField);
Alpine.data('cookieConsent', cookieConsent);
Alpine.data('dropdown', dropdown);
Alpine.data('entriesSearch', entriesSearch);
Alpine.data('entriesTranslation', entriesTranslation);
Alpine.data('entryReceiptProcessing', entryReceiptProcessing);
Alpine.data('fileUpload', fileUpload);
Alpine.data('flashLayer', flashLayer);
Alpine.data('formErrorHandler', formErrorHandler);
Alpine.data('maplibrePublic', maplibrePublic);
Alpine.data('newsItemsCategories', newsItemsCategories);
Alpine.data('opinionScale', opinionScale);
Alpine.data('scrollToInvalid', scrollToInvalid);
Alpine.data('skiplinks', skiplinks);
Alpine.data('socialMediaSharer', socialMediaSharer);
Alpine.data('highlight', highlight);
Alpine.data('voterRRN', voterRRN);
Alpine.data('nudging', nudging);

document.addEventListener('DOMContentLoaded', () => {
  Alpine.start();

  const flashMessage = document.getElementById('flash-message');
  if (flashMessage) setTimeout(flashMessage.focus(), 0);
});
